type END_POINTS_TYPES = {
    rankingApi: string
    userAPIS: string
    searchApi: string
}
export const END_POINTS: END_POINTS_TYPES = {
    rankingApi: 'futures/ranks',
    userAPIS: 'futures/',
    searchApi: 'futures/users/search',
}
